import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { T } from '../traks';
import SearchField from '../c/SearchField';
import { PublicPortfolio } from '../c/Portfolio';
import { SponsorBanner } from '../c/SponsorBanner.js';

const G = (props) => props.children;

var ExploreICE = (props) => {
	var sections = [];

	sections.push(
		<Container key="this_is_the_unique_key_for_the_icelandic_portfolio_container" className="pb-5 pt-5">
			<Row key="this_is_the_unique_key_for_the_icelandic_portfolio_row" className="ad_notification_box">
				<Col xs="12" className="p-3">
					<h3 className="p-2"><T>All stocks from Iceland</T></h3>
					<p className="pl-2"><T>
					The Icelandic stock market isn't very large, and the volume pretty low. So you can
					see all stocks from Iceland here.</T>
					</p>
				</Col>
				<Col md="12">
					<PublicPortfolio show_title={false} include_chart={false} portfolio_id={10230}/>
				</Col>
			</Row>
			<Container className="p-0">
				<SponsorBanner
					mode="iframe"
					sponsorName="Codan"
					iframeDesktopUrl="https://adops.bt.dk/stockgame/codan/desktop/index.html"
					iframeMobileUrl="https://adops.bt.dk/stockgame/codan/mobile/index.html"
				/>
			</Container>
		</Container>
	);

	const placeholder = <T>Search stocks in Iceland</T>;

	return (
		<G>
			<div className="d-flex flex-column p-5 text-center ad_game_box justify-content-center">
				<div className="ad_explore_txt_header"><T>Icelandic stocks</T></div>
				<div className="b-3 ad_explore_txt_subheader"><T>Explore stocks from Iceland</T></div>
				<SearchField placeholder={placeholder} market="IS_STOCK" form_classes="justify-content-center pt-2" input_classes="ad_search_explore_page ad_no_outline_focus" input_id="search_field_1"/>
			</div>
			<Container>
				{sections}
			</Container>
		</G>
	);
}

export default ExploreICE;



// WEBPACK FOOTER //
// ./src/p/ExploreICE.js